import Tab from "./Tab.vue";
import TabPanel from "./TabPanel.vue";

export default Tab;
export { TabPanel };
